<template>
  <div>
    <div class="share-bar">
      <template v-if="inWeChat">
        <b-button size="sm" variant="success" @click="showWeChatShareGuide">分享到微信</b-button>
        <span class="share-tip" v-if="shareGuideVisible">已设置分享内容，请点击右上角 ··· 菜单进行分享</span>
      </template>
      <template v-else>
        <b-button size="sm" variant="success" @click="showPcQrShare">微信分享</b-button>
      </template>
    </div>

    <!-- PC端微信分享二维码弹窗 -->
    <b-modal v-model="showQrModal" title="微信分享" hide-footer centered body-class="p-0">
      <div class="share-modal-content">
        <div class="share-card-preview">
          <div class="share-card-left">
            <div class="share-card-title">{{ title }}</div>
            <div class="share-card-desc">{{ desc }}</div>
          </div>
          <div class="share-card-right">
            <img :src="shareImg" class="share-card-thumb" alt="share-thumb">
          </div>
        </div>
        
        <div class="qr-section text-center mt-4 mb-3">
          <canvas ref="qrCanvas"></canvas>
          <p class="mt-2 text-muted small">打开微信，使用"扫一扫"即可分享到微信</p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { request_zzquant } from '@/network/request'
import QRCode from 'qrcode'
import logo from '@/assets/img/logo.png'

export default {
  name: 'WxShare',
  props: {
    title: {
      type: String,
      default: '自在量化 · 市场热度与量化分析'
    },
    desc: {
      type: String,
      default: '市场题材趋势量化、情绪量化与市场洞察，一起量化市场的一切'
    },
    link: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inWeChat: false,
      shareGuideVisible: false,
      showQrModal: false
    }
  },
  computed: {
    shareLink() {
      return this.link || window.location.href
    },
    shareImg() {
      let img = this.imgUrl || logo
      if (typeof img === 'string') {
        if (img.startsWith('//')) return window.location.protocol + img
        if (img.startsWith('/')) return window.location.origin + img
      }
      return img
    }
  },
  watch: {
    title() { this.updateWeChatShare() },
    desc() { this.updateWeChatShare() },
    link() { this.updateWeChatShare() },
    imgUrl() { this.updateWeChatShare() }
  },
  mounted() {
    this.inWeChat = this.isWeChatUA()
    if (this.inWeChat) {
      this.loadScript('https://res.wx.qq.com/open/js/jweixin-1.6.0.js')
        .then(() => this.initWeChatSDK())
        .catch((e) => { console.error('Load WX SDK failed', e) })
    }
  },
  methods: {
    isWeChatUA() {
      try {
        return /MicroMessenger/i.test(navigator.userAgent || '')
      } catch (e) {
        return false
      }
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        if (window.wx || window.jWeixin) {
          resolve()
          return
        }
        const s = document.createElement('script')
        s.src = src
        s.onload = resolve
        s.onerror = reject
        document.head.appendChild(s)
      })
    },
    initWeChatSDK() {
      const url = location.href.split('#')[0]
      return request_zzquant({
        url: '/v2/login/wx/js_sign',
        method: 'GET',
        params: { url }
      }).then(res => {
        const d = res && res.data && res.data.data ? res.data.data : null
        if (!d) return
        const wx = window.wx || window.jWeixin
        if (!wx) return
        wx.config({
          debug: false,
          appId: d.appId,
          timestamp: d.timestamp,
          nonceStr: d.nonceStr,
          signature: d.signature,
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareAppMessage',
            'onMenuShareTimeline'
          ]
        })
        wx.ready(() => {
          this.updateWeChatShare()
        })
        wx.error((res) => {
          console.error('WX SDK Config Error:', res)
        })
      }).catch(err => {
        console.error('WX Sign Error:', err)
      })
    },
    updateWeChatShare() {
      const wx = window.wx || window.jWeixin
      if (!wx) return
      const data = {
        title: this.title,
        desc: this.desc,
        link: this.shareLink,
        imgUrl: this.shareImg
      }
      
      // New APIs
      try { wx.updateAppMessageShareData(data) } catch(e) { console.warn('updateAppMessageShareData failed', e) }
      try { wx.updateTimelineShareData({ title: data.title, link: data.link, imgUrl: data.imgUrl }) } catch(e) { console.warn('updateTimelineShareData failed', e) }
      
      // Fallback for older versions
      try { wx.onMenuShareAppMessage(data) } catch(e) { /* ignore */ }
      try { wx.onMenuShareTimeline({ title: data.title, link: data.link, imgUrl: data.imgUrl }) } catch(e) { /* ignore */ }
    },
    showWeChatShareGuide() {
      this.shareGuideVisible = true
      setTimeout(() => { this.shareGuideVisible = false }, 4000)
      this.updateWeChatShare()
    },
    showPcQrShare() {
      this.showQrModal = true
      this.$nextTick(() => {
        const canvas = this.$refs.qrCanvas
        const url = this.shareLink
        QRCode.toCanvas(canvas, url, { width: 180, margin: 1 }, (error) => {
          if (error) console.error(error)
        })
      })
    }
  }
}
</script>

<style scoped>
.share-bar {
  display: flex;
  align-items: center;
  padding: 0px;
  background: transparent;
}
.share-bar .share-tip {
  margin-left: 5px;
  color: #888;
  font-size: 12px;
}

/* Modal Styles */
.share-modal-content {
  padding: 20px;
}

.share-card-preview {
  display: flex;
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.share-card-left {
  flex: 1;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.share-card-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.share-card-desc {
  font-size: 12px;
  color: #888;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.share-card-right {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
}

.share-card-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 2px;
}

.qr-section canvas {
  width: 180px !important;
  height: 180px !important;
}
</style>
